import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class AgGridSandbox {
  private readonly updatePropsForClientGridSubject = new Subject<void>();
  readonly updatePropsForClientGrid$ = this.updatePropsForClientGridSubject.asObservable();

  updatePropsForClientGrid(): void {
    this.updatePropsForClientGridSubject.next();
  }
}
